<template>
  <div class="recommend">
    <div class="categoryR">
      <div
        :class="{categoryRContent:true,categoryRActive:currentRecommend == item.index}"
        v-for="(item,key) in recommendC"
        :key="key"
        @click="changeCurrent(item.index)"
      >{{item.value}}</div>
    </div>
    <div class="categoryRContent" style=" padding-top: 2.5rem;">
      <!-- <div v-if="currentRecommend === 'illness'">
            <iframe src="https://m.yangshipin.cn/static/2020/c0126.html" style="width:100%;height:42rem;" />
      </div>-->
      <div v-if="currentRecommend === 'info'">
        <ContentInfo :isShowCategory="false" :origin="`recommend`" />
      </div>
      <div v-if="currentRecommend === 'video'">
        <RecommendVideo :origin="`recommend`" />
      </div>
      <div v-if="currentRecommend === 'live'">
        <RecommendLive :origin="`recommend`" />
      </div>
      <div v-if="currentRecommend === 'special'">
        <RecommendSpecial :origin="`recommend`" />
      </div>
    </div>
  </div>
</template>
<script>
import * as request from "@/utils/request";
import ContentInfo from "@/components/content/info";
import RecommendVideo from "@/components/recommend/video";
import RecommendLive from "@/components/recommend/live";
import RecommendSpecial from "@/components/recommend/special";

export default {
  components: {
    ContentInfo,
    RecommendVideo,
    RecommendLive,
    RecommendSpecial,
  },
  created() {
    if (this.$route.query.recom) {
      this.currentRecommend = this.$route.query.recom;
    }
  },
  mounted() {},
  data() {
    return {
      recommendC: [
        // {
        //     index:'illness',
        //     value:'疫情'
        // },
        {
          index: "live",
          value: "直播",
        },
        {
          index: "video",
          value: "视频",
        },
        {
          index: "info",
          value: "资讯",
        },
        {
          index: "special",
          value: "专题",
        },
      ],
      currentRecommend: "live",
      url: require("@/assets/img/content/recommend/icon_home_itemsel.png"),
    };
  },
  computed: {},
  methods: {
    changeCurrent(val) {
      this.currentRecommend = val;
    },
  },
};
</script>
<style lang="less" scope>
.recommend {
  .categoryR {
    display: flex;
    justify-content: center;
    position: fixed;
    top:3rem;
    height: 2.5em;
    background: #fff;
    align-items: center;
    z-index: 9;
    width: 100%;
    div {
      width: 3rem;
      display: inline-block;
      margin: 0.5rem 0.5rem;
      background-size: contain;
      background-repeat: no-repeat;
    }
    .categoryRActive{
        color: #379eeb;
    }
    .categoryRActive::after {
      background: #379eeb;
      content: "";
      display: block;
      margin-left: -5px;
      height: 1px;
      width: 40px;
    }
  }
  .categoryRContent {
    // padding-top: 1.5rem;
   
  }
}
</style>

